var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.554 14.227h14.649c.477 0 .934.188 1.272.523a1.78 1.78 0 0 1 0 2.526 1.805 1.805 0 0 1-1.272.524H11.525a1.805 1.805 0 0 1-1.267-.535 1.78 1.78 0 0 1 .023-2.527 1.8 1.8 0 0 1 1.276-.511h-.003ZM5.827 4H26.2c.477 0 .935.188 1.272.523a1.78 1.78 0 0 1 0 2.527 1.805 1.805 0 0 1-1.272.523H5.8a1.82 1.82 0 0 1-1.268-.528A1.796 1.796 0 0 1 4 5.786c.012-.475.209-.926.55-1.26A1.85 1.85 0 0 1 5.827 4Zm0 20.43H26.2c.477 0 .935.188 1.272.523a1.78 1.78 0 0 1 0 2.526 1.805 1.805 0 0 1-1.272.524H5.8a1.82 1.82 0 0 1-1.268-.528A1.796 1.796 0 0 1 4 26.216c.012-.475.209-.927.55-1.26a1.85 1.85 0 0 1 1.277-.526Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.19c0a0643c3ea393f21da4ffb9dce302.svg";
export { ForwardRef as ReactComponent };